var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconTelegram = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5225",
    "data-name": "Group 5225",
    width: 28.821,
    height: 28.821,
    viewBox: "0 0 28.821 28.821",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_278",
    "data-name": "Ellipse 278",
    d: "M14.41,3.043A11.367,11.367,0,1,0,25.778,14.41,11.38,11.38,0,0,0,14.41,3.043M14.41,0A14.41,14.41,0,1,1,0,14.41,14.41,14.41,0,0,1,14.41,0Z",
    fill: "#737bbb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telegram-logo-light",
    transform: "translate(5.178 6.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6672",
    "data-name": "Path 6672",
    d: "M31.2,22.635a.989.989,0,0,0-1-.175L17.245,27.545a.982.982,0,0,0,.168,1.88l3.4.68v4.223a.982.982,0,0,0,.6.9,1.045,1.045,0,0,0,.379.077.968.968,0,0,0,.694-.288l1.915-1.915,2.862,2.518a.961.961,0,0,0,.645.246.9.9,0,0,0,.3-.049.968.968,0,0,0,.652-.715L31.513,23.6A.982.982,0,0,0,31.2,22.635ZM17.47,28.471a.126.126,0,0,1,.084-.14l10.838-4.258-7.253,5.24L17.582,28.6a.126.126,0,0,1-.112-.126ZM21.9,34.426a.133.133,0,0,1-.154.028.14.14,0,0,1-.084-.126V30.687l2.111,1.866Zm6.159.491a.14.14,0,0,1-.231.077l-5.913-5.2,8.768-6.327Z",
    transform: "translate(-16.081 -21.856)",
    fill: "#737bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6672_-_Outline",
    "data-name": "Path 6672 - Outline",
    d: "M28.087,19.393a1.541,1.541,0,0,1,.963.342l.007-.005,0,.01.031.026a1.516,1.516,0,0,1,.488,1.486L26.929,32.764a1.507,1.507,0,0,1-1.013,1.107,1.417,1.417,0,0,1-.457.074,1.5,1.5,0,0,1-1.011-.383l-2.48-2.182-1.559,1.559a1.513,1.513,0,0,1-1.068.445,1.593,1.593,0,0,1-.587-.117,1.517,1.517,0,0,1-.938-1.4V28.082l-2.97-.594a1.519,1.519,0,0,1-.257-2.907L27.535,19.5A1.524,1.524,0,0,1,28.087,19.393Zm-1.955,2.448,1.9-1.37a.451.451,0,0,0-.106.027l-2.08.817Zm-.915,9.848,2.157-9.42-7.067,5.1Zm-6.665-5.412,3.616-2.613-5.624,2.21Zm1.971,3.838-.791-.7v1.49Z",
    transform: "translate(-13.618 -19.393)",
    fill: "#737bbb"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconTelegram, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-telegram.426aa37c.svg";
export { ForwardRef as ReactComponent };